import BundleProvider from '../providers/BundleProvider'
import BundleCard from '../components/BundleCard/BundleCard'

export default BundleProvider(BundleCard)
